(function () {
    'use strict';

    angular
        .module('salesflare')
        .controller('JoinExistingTeamDialogController', JoinExistingTeamDialogController);

    function JoinExistingTeamDialogController($mdDialog, $translate) {

        const vm = this;

        vm.$onInit = () => {

            let headerText = '';

            if (vm.relatedTeams.length > 1) {
                headerText += $translate.instant('There are multiple Salesflare teams for your company');
            }
            else {
                headerText += $translate.instant('There\'s already a Salesflare team for your company');
            }

            vm.headerText = headerText;

            vm.relatedTeams.forEach((relatedTeam) => {

                relatedTeam.adminNames = relatedTeam.admins.map((admin) => admin.name).join(', ').replace(/, ([^,]*)$/, ' ' + $translate.instant('and') + ' $1');
            });
        };

        vm.joinTeam = (id) => {

            return $mdDialog.hide(id);
        };

        vm.close = $mdDialog.hide;
    }
})();
